var map = {
	"./music-instructions.json": 5472,
	"./music-library-intro2024.json": 5473,
	"./music-library-launch2024.json": 5474,
	"./music-progression.json": 5475,
	"./startSourcesAdvanced.json": 5476,
	"./startSourcesSimple.json": 5477,
	"./startSourcesSimple2.json": 5478,
	"./startSourcesTracks.json": 5479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5035;